import config from "../../config/index";
import requestOptions from "@/helpers/RequestOptions";
import handleResponse from "@/helpers/HandleResponses";
import handleBlobResponse from "@/helpers/HandleBlobResponses";

export const trainingService = {
  exportPlan,
  getCurrentTrainingPlan,
  getCurrentConfirmedTrainingNeed,
  getCurrentTrainingNeedByEmployee,
  getCurrentTrainingNeedByManager,
  getCurrentTrainingNeeds,
  getCurrentGroupTrainingPlan,
  getSkillGap,
  getTrainingProgrammes,
  getTrainingProgrammesBySkillGap,
  getTrainingProviders,
  getTrainingProvidersByProgramme,
  getCurrentGroupTrainingPlanNeed,
  addNeed,
  removeNeed,
  editNeed,
  addGroupNeed,
  removeGroupNeed,
  editGroupNeed,
  addProgramme,
  editProgramme,
  removeProgramme,
  addPlan,
  editPlan,
  removePlan,
  addGroupPlan,
  editGroupPlan,
  removeGroupPlan,
  addProvider,
  editProvider,
  removeProvider,
  addSkillGap,
  editSkillGap,
  removeSkillGap,
  downloadPlanTemplate,
  downloadProgrammeTemplate,
  downloadProviderTemplate,
  importPlan,
  importProgram,
  importProvider,
  importProviderCurriculum
};

function getCurrentTrainingPlan(id) {
  return fetch(
    `${config.apiurl}/Training/GetCurrentTrainingPlan/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCurrentGroupTrainingPlan(id) {
  return fetch(
    `${config.apiurl}/Training/GetCurrentGroupTrainingPlan/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCurrentGroupTrainingPlanNeed(id) {
  return fetch(
    `${config.apiurl}/Training/GetCurrentGroupTrainingPlanNeed/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function exportPlan(id, year) {
  return fetch(
    `${config.apiurl}/Training/ExportPersonalTrainingPlan?companyId=${id}&Year=${year}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function getCurrentConfirmedTrainingNeed(id) {
  return fetch(
    `${config.apiurl}/Training/GetCurrentConfirmedTrainingNeed/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCurrentTrainingNeedByEmployee(id) {
  return fetch(
    `${config.apiurl}/Training/GetCurrentTrainingNeedByEmployee/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCurrentTrainingNeedByManager(id) {
  return fetch(
    `${config.apiurl}/Training/GetCurrentTrainingNeedByManager/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getCurrentTrainingNeeds(id) {
  return fetch(
    `${config.apiurl}/Training/GetCurrentTrainingNeeds/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getSkillGap(id) {
  return fetch(
    `${config.apiurl}/Training/GetSkillGap/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getTrainingProgrammes(id) {
  return fetch(
    `${config.apiurl}/Training/GetTrainingProgrammes/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getTrainingProgrammesBySkillGap(id) {
  return fetch(
    `${config.apiurl}/Training/GetTrainingProgrammesBySkillGap/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getTrainingProviders(id) {
  return fetch(
    `${config.apiurl}/Training/GetTrainingProviders/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function getTrainingProvidersByProgramme(id) {
  return fetch(
    `${config.apiurl}/Training/GetTrainingProvidersByProgramme/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      // console.log(model)
      return model;
    });
}
function downloadPlanTemplate(id) {
  return fetch(
    `${config.apiurl}/Training/DownloadPlanTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadProviderTemplate(id) {
  return fetch(
    `${config.apiurl}/Training/DownloadProviderTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadProgrammeTemplate(id) {
  return fetch(
    `${config.apiurl}/Training/DownloadProgrammeTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function importProgram(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/training/importProgramme`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importProvider(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/training/importProvider`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importProviderCurriculum(ProviderId, UploadFile) {
  let formData = new FormData();
  formData.append("ProviderId", ProviderId);
  formData.append("UploadFile", UploadFile);
  return fetch(
    `${config.apiurl}/Training/AddCurriculum`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function importPlan(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/training/importPlan`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addNeed(req) {
  return fetch(`${config.apiurl}/Training/PostNeed`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function editNeed(id, req) {
  return fetch(
    `${config.apiurl}/Training/UpdateNeed/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeNeed(id) {
  return fetch(
    `${config.apiurl}/Training/DeleteNeed/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addGroupNeed(req) {
  return fetch(
    `${config.apiurl}/Training/PostGroupNeed`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function editGroupNeed(req) {
  return fetch(
    `${config.apiurl}/Training/UpdateGroupNeed/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeGroupNeed(id) {
  return fetch(
    `${config.apiurl}/Training/DeleteGroupNeed/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addProgramme(req) {
  return fetch(
    `${config.apiurl}/Training/PostProgramme`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function editProgramme(req) {
  return fetch(
    `${config.apiurl}/Training/UpdateProgramme/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeProgramme(id) {
  return fetch(
    `${config.apiurl}/Training/DeleteProgramme/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addPlan(req) {
  return fetch(`${config.apiurl}/Training/PostPlan`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function editPlan(req) {
  return fetch(
    `${config.apiurl}/Training/UpdatePlan/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removePlan(id) {
  return fetch(
    `${config.apiurl}/Training/DeletePlan/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addGroupPlan(req) {
  return fetch(
    `${config.apiurl}/Training/PostGroupPlan`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function editGroupPlan(req) {
  return fetch(
    `${config.apiurl}/Training/UpdateGroupPlan/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeGroupPlan(id) {
  return fetch(
    `${config.apiurl}/Training/DeleteGroupPlan/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addProvider(req) {
  return fetch(
    `${config.apiurl}/Training/PostProvider`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function editProvider(req) {
  return fetch(
    `${config.apiurl}/Training/UpdateProvider/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeProvider(id) {
  return fetch(
    `${config.apiurl}/Training/DeleteProvider/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addSkillGap(req) {
  return fetch(
    `${config.apiurl}/Training/PostSkillGap`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function editSkillGap(req) {
  return fetch(
    `${config.apiurl}/Training/UpdateSkillGap/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeSkillGap(id) {
  return fetch(
    `${config.apiurl}/Training/DeleteSkillGap/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}



// WEBPACK FOOTER //
// ./src/services/trainingService.js